module.exports = __webpack_public_path__ + "img/geod_4.f0b73c26.jpg";